import React, { useContext, useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import { StringParam, useQueryParam } from 'use-query-params';
import SearchField from '../../../../components/ui/filterSearch/components/searchField';
import { MicrocopyContext } from '../../../../context/microcopy.context';
import { getCopy } from '../../../../helpers/copy';
import Logo from '../../../../images/logo.svg';
import * as styles from './styles.module.scss';
import Container from '../../../container';
import { useLocale } from '../../../../context/locale.context';

const SearchOverlay = ({ onClose }) => {
  const { locale } = useLocale();
  const [searchParam, _] = useQueryParam('q', StringParam);
  const [searchTerm, setSearchTerm] = useState(null);
  const microcopy = useContext(MicrocopyContext);

  useEffect(() => {
    setSearchTerm(searchParam);
  }, [searchParam]);

  const submitHandler = (value) => {
    setSearchTerm(value);
    if (value) {
      return navigate(`/${locale}/search?find=${encodeURIComponent(value)}`);
    }
  };

  return (
    <Container>
      <Logo className={styles.logo} />
      <div className={styles.searchContainer}>
        <SearchField
          initSearchTerm={searchTerm}
          onSubmit={submitHandler}
          onReset={() => setSearchTerm(null)}
          placeholder={getCopy('search.input.placeholder', microcopy)}
          type="Global"
          autoFocus
          disableActiveBackdropStyles
          onBackdropClick={onClose}
          small
        />
      </div>
      <div className={styles.searchOverlay} onClick={onClose} />
    </Container>
  );
};

export default SearchOverlay;
